import Vue from 'vue'
import Vuex from 'vuex'

import { localstorageStore } from '@/plugins/localforage'

import { objects } from './objects'
import { slugs } from './slugs'
import { menus } from './menus'
import { mails } from './mails'
import { error } from './error'
import { warning } from './warning'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isOnline: true,
    locale: null,
    locales: ['fr', 'en', 'de'],
    apiEndoint: process.env.NODE_ENV === 'production'
      ? '/api'
      : 'http://localhost:3030/api',
    offlineMapZoom: 9,
  },

  mutations: {
    setLocale(state, locale) {
      state.locale = locale
    },

    setOnline(state, online) {
      state.isOnline = online
    },

    setOfflineMapZoom(state, zoom) {
      state.offlineMapZoom = zoom
    },
  },

  actions: {
    checkIfIsOnline({ commit }) {
      const online = navigator.onLine
      commit('setOnline', online)

      return online
    },

    async getOfflineMapZoom({ commit }) {
      const zoom = await localstorageStore.getItem('mapZoom')

      commit('setOfflineMapZoom', zoom)
    },
  },

  getters: {
    isIos() {
      return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
  },

  modules: { objects, slugs, menus, mails, error, warning },
})
